/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global.js" ;
	import * as helper from "../../js/helper.js";
	import full_loading from "../components/full-loading.vue";
    import VueSelect from '../../js/vue-select.js';
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            vue_select:VueSelect,
        },
		name:'transfer_mashro_modal',
        props: {
        },
		data() {
			return {
                global,
                helper,
                is_loading:false,
				mashro_name: null,
				mashro_title: null,
				member_name: null,
                transfer_to: 'Agency',
				members: [],
                to_member: null,
			}
		},
        mounted(){
            var exampleModal = document.getElementById('transfer-mashro-modal')
            exampleModal.addEventListener('show.bs.modal', this.load_data)
        },
		methods: {
            resetForm: function () {
                
                // mashro_name: null,
				// member_name: null,
                // transfer_to: 'Agency',
				// members: [],
                // to_member: null,
                this.mashro_name = null;
                this.mashro_title = null;
                this.member_name = null;
                this.members = [];
                this.transfer_to = "Agency";
                this.to_member = null;
            },
            load_data: async function(event){
                if(this.is_loading)
                    return;
                this.resetForm();
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                var button = event.relatedTarget;
                this.mashro_name = button.getAttribute('data-bs-mashro-name');
                this.mashro_title = button.getAttribute('data-bs-mashro-title');
                this.member_name = button.getAttribute('data-bs-member-name');
                while(this.members.length > 0) {
                    this.members.pop();
                }
                let params = {
                    'mashro_managers':1,
                    'filters':JSON.stringify(this.filters)
                };
                let url = "/api/method/maalek.api.get_agency_members";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                for (let index = 0; index < res.message.length; index++) {
                    this.members.push(res.message[index]);
                }
                this.is_loading = false;
                global.emitter.emit("hide-full-loading");
            },
            transfer_mashro: async function(){
				try {
					global.emitter.emit("show-full-loading");
					let params = {
                        'mashro_name':    this.mashro_name,
                    };
                    if (this.transfer_to=='Member')
                        params['to_member'] = this.to_member["member"];
                    
					let res = await $.ajax({
						headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
						url: "/api/method/maalek.api.transfer_mashro",
						type: "POST",
						// data: params //for GET request
						data: JSON.stringify(params) //for POST request
					});
                    console.log("success");
					global.emitter.emit("hide-full-loading");
                    $("#transfer-mashro-modal").modal('hide');
                    helper.showSuccess("Transfered successfully",()=>{
                        location.reload();
                    });
				} catch (e) {
					console.log(e);
                    var exceptions = helper.showException(e);
				}
			},
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "transfer-mashro-modal",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-centered modal-dialog-scrollable"
        },
        [
          _vm.mashro_name && _vm.members.length > 0
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.helper.t("Transfer Project: {0}", [
                            _vm.mashro_title
                          ])
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "form-group mb-3" }, [
                        _c(
                          "label",
                          {
                            staticClass: "toggler mb-2",
                            attrs: { id: "filt-yearly" }
                          },
                          [_vm._v(_vm._s(_vm.helper.t("Transfer project to:")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn-toolbar",
                            attrs: {
                              role: "toolbar",
                              "aria-label": "Toolbar with button groups"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group me-2",
                                attrs: { role: "group" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn",
                                    class:
                                      _vm.transfer_to == "Agency"
                                        ? "btn-primary"
                                        : "btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.transfer_to = "Agency"
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.helper.t("to the Company"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn",
                                    class:
                                      _vm.transfer_to == "Member"
                                        ? "btn-primary"
                                        : "btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.transfer_to = "Member"
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.helper.t("to another member"))
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.transfer_to == "Member"
                    ? _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _vm.members.length == 1 &&
                              _vm.members[0]["member"] == _vm.member_name
                                ? _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.helper.t(
                                          "No other member available"
                                        )
                                      )
                                    )
                                  ])
                                : _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.helper.t("select manager"))
                                    )
                                  ]),
                              _vm._v(" "),
                              _vm.members.length > 1 ||
                              _vm.members[0]["member"] != _vm.member_name
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.to_member,
                                          expression: "to_member"
                                        }
                                      ],
                                      staticClass:
                                        "form-select form-control border-radius",
                                      attrs: {
                                        "aria-label": "Default select example"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.to_member = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }),
                                      _vm._v(" "),
                                      _vm._l(_vm.members, function(member) {
                                        return member["member"] !=
                                          _vm.member_name
                                          ? _c(
                                              "option",
                                              { domProps: { value: member } },
                                              [
                                                _vm._v(
                                                  _vm._s(member["full_name"]) +
                                                    " - (0" +
                                                    _vm._s(
                                                      member[
                                                        "member"
                                                      ].substring(4)
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col show-hand text-end" }, [
                      _vm.transfer_to == "Agency" ||
                      (_vm.transfer_to == "Member" && _vm.to_member)
                        ? _c(
                            "a",
                            {
                              staticClass: "btn default-btn mt-2",
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.transfer_mashro()
                                }
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.helper.t("Transfer Project")))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn default-btn show-hand mt-2",
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeModal("#transfer-dialog")
                            }
                          }
                        },
                        [_c("p", [_vm._v(_vm._s(_vm.helper.t("No wait!")))])]
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-ece47bae_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"transfer-mashro-modal.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/transfer-mashro-modal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__